let jarva = () => {
  let $ = window.jQuery
  let init = () => {
    $(document).ready(() => {
      $('.header-text').scrollClass()
      $('.bumper-div p').scrollClass()
      $('.bumper-div .p-dummy').scrollClass()
      $('.text-box').scrollClass()
      $('a').click(function () {
        let href = $(this).attr('href')
        let target = $(this).attr('target')
        let aClass = $(this).attr('class')
        if (href === '#') {
          $('html, body')
            .animate({
              scrollTop: $(window).height()
            }, 'slow', 'swing', function () { })
        } else {
          if (target === '_blank' || aClass === 'remove') {
          } else {
            $('#page').fadeOut('slow')
            $('footer').fadeOut('slow')
            $('.mobile-nav').removeClass('open')
          }
        }
      })
      $('.menu-toggle').click(() => {
        $('.menu-toggle').toggleClass('open')
        $('.mobile-nav').toggleClass('open')
      })
    })
  }
  return {
    init: init
  }
}

let initMap = () => {
  let div = document.getElementById('map-hitta')
  if (!div) {
    return false
  }
  var mapStyle = [
    {
      'featureType': 'all',
      'elementType': 'labels.icon',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'administrative',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'color': '#eeeeee'
        }
      ]
    },
    {
      'featureType': 'administrative.country',
      'elementType': 'geometry',
      'stylers': [
        {
          'lightness': '100'
        }
      ]
    },
    {
      'featureType': 'administrative.country',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'administrative.province',
      'elementType': 'all',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'administrative.locality',
      'elementType': 'labels.text',
      'stylers': [
        {
          'visibility': 'simplified'
        },
        {
          'color': '#777777'
        }
      ]
    },
    {
      'featureType': 'administrative.locality',
      'elementType': 'labels.icon',
      'stylers': [
        {
          'visibility': 'simplified'
        },
        {
          'lightness': 60
        }
      ]
    },
    {
      'featureType': 'administrative.neighborhood',
      'elementType': 'all',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'administrative.land_parcel',
      'elementType': 'all',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'landscape.man_made',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'saturation': '-100'
        }
      ]
    },
    {
      'featureType': 'landscape.man_made',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'landscape.natural',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#e0e0e0'
        }
      ]
    },
    {
      'featureType': 'landscape.natural',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'simplified'
        }
      ]
    },
    {
      'featureType': 'poi',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#eeeeee'
        }
      ]
    },
    {
      'featureType': 'poi',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'poi.attraction',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#c7c7c7'
        }
      ]
    },
    {
      'featureType': 'poi.business',
      'elementType': 'all',
      'stylers': [
        {
          'visibility': 'simplified'
        }
      ]
    },
    {
      'featureType': 'poi.business',
      'elementType': 'labels.icon',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'poi.government',
      'elementType': 'all',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'poi.medical',
      'elementType': 'all',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'poi.park',
      'elementType': 'all',
      'stylers': [
        {
          'color': '#cccccc'
        },
        {
          'invert_lightness': true
        }
      ]
    },
    {
      'featureType': 'poi.park',
      'elementType': 'geometry',
      'stylers': [
        {
          'invert_lightness': true
        }
      ]
    },
    {
      'featureType': 'poi.park',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'road.highway',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#e5e5e5'
        },
        {
          'visibility': 'simplified'
        }
      ]
    },
    {
      'featureType': 'road.highway',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'road.arterial',
      'elementType': 'geometry.stroke',
      'stylers': [
        {
          'color': '#dddddd'
        },
        {
          'visibility': 'on'
        }
      ]
    },
    {
      'featureType': 'road.arterial',
      'elementType': 'labels.text',
      'stylers': [
        {
          'visibility': 'simplified'
        }
      ]
    },
    {
      'featureType': 'road.arterial',
      'elementType': 'labels.icon',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'road.local',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'color': '#ffffff'
        }
      ]
    },
    {
      'featureType': 'road.local',
      'elementType': 'geometry.stroke',
      'stylers': [
        {
          'visibility': 'off'
        },
        {
          'color': '#ffffff'
        }
      ]
    },
    {
      'featureType': 'road.local',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'simplified'
        }
      ]
    },
    {
      'featureType': 'road.local',
      'elementType': 'labels.text',
      'stylers': [
        {
          'color': '#777777'
        },
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'road.local',
      'elementType': 'labels.icon',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'transit.line',
      'elementType': 'geometry',
      'stylers': [
        {
          'color': '#cccccc'
        }
      ]
    },
    {
      'featureType': 'transit.line',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    },
    {
      'featureType': 'transit.station',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'color': '#eeeeee'
        }
      ]
    },
    {
      'featureType': 'water',
      'elementType': 'all',
      'stylers': [
        {
          'visibility': 'simplified'
        }
      ]
    },
    {
      'featureType': 'water',
      'elementType': 'geometry.fill',
      'stylers': [
        {
          'color': '#ffffff'
        }
      ]
    },
    {
      'featureType': 'water',
      'elementType': 'labels',
      'stylers': [
        {
          'visibility': 'off'
        }
      ]
    }
  ]
  console.log(initMap, mapStyle)
  window.map = new window.google.maps.Map(div, {
    center: {lat: 59.319507, lng: 18.065838},
    zoom: 14,
    disableDefaultUI: true
  })
  var styledMapType = new window.google.maps.StyledMapType(mapStyle)
  window.map.mapTypes.set('styled_map', styledMapType)
  window.map.setMapTypeId('styled_map')
  let marker = new window.google.maps.Marker({
    position: { lat: 59.319507, lng: 18.065838 },
    map: window.map,
    icon: ' ',
    label: {
      fontFamily: 'Fontawesome',
      text: '\uf041',
      fontSize: '36px',
      color: '#fc442a'
    },
    title: 'Accomplice'
  })
  console.log(marker)
}

let jarvax = jarva()
jarvax.init()
